export const isViewTransitionSupported = () => {
    return 'startViewTransition' in document;
};

export const startViewTransition = (cb: () => Promise<void>) => {
    // typescript from version 5.6 has this type
    (document as any).startViewTransition(cb);
};
